"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _useGlow = _interopRequireDefault(require("../../utils/useGlow"));
var _Interstitial = _interopRequireWildcard(require("./Interstitial.styles"));
var _InvertIcon = _interopRequireDefault(require("./InvertIcon"));
var _Modal = _interopRequireWildcard(require("../../components/Modal"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _excluded = ["className", "color", "iconName", "height", "onClose", "open", "subText", "title", "width", "autoHideDuration"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var AUTO_HIDE_DURATION = 2000;
var mapErrorColor = function mapErrorColor(color) {
  return color === "error" ? "alert" : color;
};
var Interstitial = function Interstitial(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "primary" : _ref$color,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? "check" : _ref$iconName,
    height = _ref.height,
    onClose = _ref.onClose,
    open = _ref.open,
    subText = _ref.subText,
    title = _ref.title,
    width = _ref.width,
    autoHideDuration = _ref.autoHideDuration,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(open !== null && open !== void 0 ? open : true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var theme = (0, _reactJss.useTheme)();
  var classes = (0, _Interstitial.default)(_Interstitial.interstitialVars.useVars({
    width: width,
    height: height
  }));
  var backgroundColor = theme.colors[mapErrorColor(color)];
  (0, _react.useEffect)(function () {
    if (typeof open !== "undefined") {
      setIsOpen(open);
    }
    var timeSet = setTimeout(function () {
      if (onClose) {
        onClose();
      }
      if (typeof open === "undefined") {
        setIsOpen(false);
      }
    }, autoHideDuration !== null && autoHideDuration !== void 0 ? autoHideDuration : AUTO_HIDE_DURATION);
    return function () {
      return clearTimeout(timeSet);
    };
  }, [autoHideDuration, onClose, open]);
  var modalProps = _objectSpread({
    className: (0, _classnames.default)(classes.root, classes.variables, classes.blur, className),
    disableCloseButton: true,
    dismissible: false,
    open: isOpen,
    size: _Modal.ModalSizes.medium
  }, otherProps);
  var iconProps = {
    backgroundColor: backgroundColor,
    className: (0, _useGlow.default)(backgroundColor),
    fill: theme.colors.textOnDark,
    name: iconName
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, modalProps, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, title && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.title)
  }, title), iconName && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.icon
  }, /*#__PURE__*/_react.default.createElement(_InvertIcon.default, iconProps)), subText && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.subText)
  }, subText)));
};
Interstitial.displayName = "Interstitial";
var Storybook = exports.Storybook = Interstitial;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/feedback-interstitial--docs
 */
var exportedComponent = (0, _defaultProps.default)(Interstitial);
exportedComponent.displayName = "Interstitial";
var _default = exports.default = exportedComponent;